import moment from "moment";

import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";
import { Popup } from "@/Common/Components/Modals/Popup";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { Guid } from "@/Common/Models/Guid";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientUIModel } from "@/Patient/Models/UI/IPatientUIModel";

interface IPatientMemoPopupProps {
    PatientId: string;
    Model: IPatientUIModel;
}

class PatientMemoState {
    public MemoText: string;
    public MemoDate: Date;
    public MemoUserId: Guid;
}

class PatientMemoPopup extends React.Component<IPatientMemoPopupProps, PatientMemoState> {
    private id: string = "popupmenu";

    constructor(props: IPatientMemoPopupProps) {
        super(props);

        const patientIndividualResponse = patientStore.PatientModels[this.props.PatientId].IndividualResponse;
        const initialState = new PatientMemoState();
        initialState.MemoDate = patientIndividualResponse.MemoLastModifiedDate;
        initialState.MemoText = patientIndividualResponse.MemoNote ? patientIndividualResponse.MemoNote : "";
        initialState.MemoUserId = patientIndividualResponse.LastModifiedMemoEmployeeId;
        this.state = initialState;
    }

    public render(): JSX.Element {
        let employeeName = "";
        if (this.state.MemoUserId) {
            const employee = cacheStore.GetEmployeeByContactFacetId(this.state.MemoUserId);

            if (employee) {
                employeeName = employee.LastName + ", " + employee.FirstName;
            }
        }

        let memodateString = (this.state.MemoDate) ? moment(this.state.MemoDate).format("YYYY-MM-DD HH:mm:SS") : "";

        return (
            <Popup
                Id={this.id}
                title={cacheStore.GetString("MemoLabel")}
                draggable
                manageOverlay
                centeredHorizontally
                width={550}
                closeTarget={LocalPatientOperations.Profile.CancelMemoClick}
            >
                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            {!this.props.Model.get("IsProfileMemoEditMode") && (
                                <div className="row">
                                    <div className="col-sm-4">
                                        {!IsNullOrWhiteSpace(employeeName) && (
                                            <>
                                                {employeeName} <br />
                                            </>
                                        )}
                                        {memodateString}
                                    </div>
                                    <div className="col-sm-8">
                                        <span> {JSXHelper.BreakStringIntoParagraphs(this.state.MemoText)} </span>
                                    </div>
                                </div>
                            )}
                            {this.props.Model.get("IsProfileMemoEditMode") && (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <TextAreaAutoSize
                                            id="memo_text"
                                            ref="memo_text"
                                            value={this.state.MemoText}
                                            onTextChangeCallback={value => this.MemoTextChanged(value)}
                                            minHeight="7em"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                {this.props.Model.get("IsProfileMemoEditMode") && (
                                    <div>
                                        <button data-action="save" className="btn btn-default push-right-5" onClick={e => this.CancelEditClick(e)}>{cacheStore.GetString("CancelLabel")}</button>
                                        <button data-action="cancel" className="btn btn-primary push-right-5" onClick={e => this.SaveClick(e)}>{cacheStore.GetString("SaveLabel")}</button>
                                    </div>
                                )}
                                {!this.props.Model.get("IsProfileMemoEditMode") && (
                                    <div>
                                        <button data-action="cancel" className="btn btn-default push-right-5" onClick={e => this.CancelClick(e)}>{cacheStore.GetString("CancelLabel")}</button>
                                        <button data-action="modify" className="btn btn-primary push-right-5" onClick={e => this.EditClick(e)}>{cacheStore.GetString("ModifyLabel")}</button>
                                        <button data-action="delete" className="btn btn-danger push-right-5" onClick={e => this.DeleteClick(e)}>{cacheStore.GetString("DeleteLabel")}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private MemoTextChanged(value: string): void {
        var s = new PatientMemoState();
        s.MemoText = value;
        this.setState(s);
    }

    private CancelClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.CancelMemoClick);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private CancelEditClick(e: React.MouseEvent): void {
        e.preventDefault();

        if (!patientStore.PatientModels[this.props.PatientId].IndividualResponse.MemoNote) {
            var operation = new LocalEvent(LocalPatientOperations.Profile.CancelMemoClick);
            LocalEventDispatcher.dispatch(operation);
        }
        else {
            var operation = new LocalEvent(LocalPatientOperations.Profile.CancelEditMemoClick);
            LocalEventDispatcher.dispatch(operation);
        }

        e.preventDefault();
    }

    private DeleteClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.DeleteMemoClick);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private EditClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.EditMemoClick);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private SaveClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.SaveMemoClick);
        operation.AddItem("value", this.state.MemoText);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PatientMemoPopup, PatientMemoState };
